import React, { useEffect, useState } from "react";
import { getOrganismoEmisor, postOrganismoEmisor, putOrganismoEmisor, postRelacionOrganismoTipoDocumento } from "../../componentes/http/actions/OrganismoEmisorAction";
import EditNoteIcon from "@mui/icons-material/EditNote";
import {Settings as SettingsIcon} from "@mui/icons-material";
import {
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Grid,
  Typography,
  Box,
  Snackbar,
  Alert,
  TablePagination,
  CircularProgress,
  Chip,
  IconButton,
  Tooltip,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import NuevoOrganismoEmisorModal from "../../componentes/modal/OrganismoEmisor/NuevoOrganismoEmisorModal";
import EditarOrganismoEmisorModal from "../../componentes/modal/OrganismoEmisor/EditarOrganismoEmisorModal";
import AgregarRelacionOrganismoTipoDocumentoModal from "../../componentes/modal/OrganismoEmisor/AgregarRelacionOrganismoTipoDocumentoModal";
import FilterComponent from "../../componentes/data/FilterComponent";

const GestorOrganismoEmisor = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  
  const [organismoEmisor, setOrganismoEmisor] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [organismoSeleccionado, setOrganismoSeleccionado] = useState(null);
  const [openRelacionModal, setOpenRelacionModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterHabilitado, setFilterHabilitado] = useState("todos");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    fetchOrganismoEmisor();
  }, []);

  const fetchOrganismoEmisor = () => {
    setIsLoading(true);
    getOrganismoEmisor(localStorage.getItem("token"))
      .then((response) => {
        setOrganismoEmisor(Array.isArray(response) ? response : []);
      })
      .catch((error) => {
        console.log(error);
        setOrganismoEmisor([]);
        setSnackbar({
          open: true,
          message: "Error al cargar organismos emisores",
          severity: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
        setInitialDataLoaded(true);
      });
  };

  const filterOptions = [
    { value: "todos", label: "Todos" },
    { value: "habilitado", label: "Habilitados" },
    { value: "deshabilitado", label: "Deshabilitados" },
  ];

  const filteredOrganismos = organismoEmisor
    .filter((organismo) => {
      const matchesSearch = organismo.nombre
        .toLowerCase()
        .includes(searchTerm.toLowerCase());
      const matchesFilter =
        filterHabilitado === "todos" ||
        (filterHabilitado === "habilitado" && organismo.habilitado === true) ||
        (filterHabilitado === "deshabilitado" &&
          organismo.habilitado === false);
      return matchesSearch && matchesFilter;
    })
    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  const handleSearchChange = (newSearchTerm) => {
    setSearchTerm(newSearchTerm);
    setPage(0);
  };
  
  const handleFilterChange = (newFilter) => {
    setFilterHabilitado(newFilter);
    setPage(0);
  };

  // Modal de nuevo organismo emisor
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  // Modal de editar organismo emisor
  const handleOpenEditModal = (organismo) => {
    setOrganismoSeleccionado(organismo);
    setOpenEditModal(true);
  };
  const handleCloseEditModal = () => {
    setOpenEditModal(false);
    setOrganismoSeleccionado(null);
  };

  // Modal de gestionar tipos de documento
  const handleOpenRelacionModal = (organismo) => {
    setOrganismoSeleccionado(organismo);
    setOpenRelacionModal(true);
  };
  const handleCloseRelacionModal = () => {
    setOpenRelacionModal(false);
    setOrganismoSeleccionado(null);
  };

  const handleNuevoOrganismoEmisor = async (organismo) => {
    try {
      setIsLoading(true);
      await postOrganismoEmisor(localStorage.getItem("token"), organismo);
      await fetchOrganismoEmisor();
      handleCloseModal();
      setSnackbar({
        open: true,
        message: "Organismo emisor agregado con éxito",
        severity: "success",
      });
    } catch (error) {
      console.error("Error al agregar nuevo organismo emisor:", error);
      setSnackbar({
        open: true,
        message: "Error al agregar organismo emisor: organismo ya existe o error en los datos",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditarOrganismoEmisor = async (organismo) => {
    try {
      setIsLoading(true);
      await putOrganismoEmisor(localStorage.getItem("token"), organismo);
      await fetchOrganismoEmisor();
      handleCloseEditModal();
      setSnackbar({
        open: true,
        message: "Organismo emisor editado con éxito",
        severity: "success",
      });
    } catch (error) {
      console.error("Error al editar organismo emisor:", error);
      setSnackbar({
        open: true,
        message: "Error al editar organismo emisor: organismo ya existe o error en los datos",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleRelacionarTiposDocumento = async (relacion) => {
    try {
      setIsLoading(true);
      await postRelacionOrganismoTipoDocumento(localStorage.getItem("token"), relacion);
      setSnackbar({
        open: true,
        message: "Tipos de documento relacionados con éxito",
        severity: "success",
      });
      fetchOrganismoEmisor();
      handleCloseRelacionModal();
    } catch (error) {
      console.error("Error al relacionar tipos de documento:", error);
      setSnackbar({
        open: true,
        message: "Error al relacionar tipos de documento",
        severity: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const renderNoDataMessage = () => (
    <TableContainer component={Paper}>
      <Box p={3} sx={{ 
        width: '100%', 
      }}>
        <Typography variant="body1" color="text.secondary">
          No se encontraron organismos emisores con los criterios de búsqueda actuales.
        </Typography>
      </Box>
    </TableContainer>
  );

  // Renderizado responsivo de la tabla
  const renderMobileCard = (organismo, index) => (
    <Paper key={index} sx={{ p: 2, mb: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
        <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 'bold' }}>
          {organismo.sigla}
        </Typography>
        <Chip
          label={organismo.habilitado ? "Habilitado" : "Deshabilitado"}
          color={organismo.habilitado ? "success" : "error"}
          size="small"
        />
      </Box>
      
      <Typography variant="body2" sx={{ mb: 1 }}>
        <strong>ID:</strong> {organismo.id}
      </Typography>
      
      <Typography variant="body2" sx={{ mb: 1 }}>
        <strong>Nombre:</strong> {organismo.nombre}
      </Typography>
      
      <Typography variant="body2" sx={{ mb: 1 }}>
        <strong>Nombre Abreviado:</strong> {organismo.nombreAbreviado}
      </Typography>
      
      <Typography variant="body2" sx={{ mb: 2 }}>
        <strong>Tipos de Documento:</strong>
      </Typography>
      
      {organismo.tipoDocumento && organismo.tipoDocumento.length > 0 ? (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 2 }}>
          {organismo.tipoDocumento.map((tipo, idx) => (
            <Chip
              key={idx}
              label={tipo}
              size="small"
              variant="outlined"
            />
          ))}
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Sin tipos asociados
        </Typography>
      )}
      
      <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
        <Tooltip title="Editar organismo">
          <IconButton
            color="primary"
            onClick={() => handleOpenEditModal(organismo)}
            size="small"
          >
            <EditNoteIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Gestionar tipos de documento">
          <IconButton
            color="primary"
            onClick={() => handleOpenRelacionModal(organismo)}
            size="small"
          >
            <SettingsIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Paper>
  );

  return (
    <Grid container direction="column" spacing={2} sx={{paddingTop: {xs: '20px', sm: '10px'}}}>
      <Grid item>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="h4">Organismo emisor</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpenModal}
            disabled={isLoading}
          >
            Añadir organismo emisor
          </Button>
        </Grid>
      </Grid>
      <Grid item>
        <FilterComponent
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          filterValue={filterHabilitado}
          onFilterChange={handleFilterChange}
          filterOptions={filterOptions}
        />
      </Grid>
      <Grid item>
        {isLoading && !initialDataLoaded ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : filteredOrganismos.length > 0 ? (
          <>
            {isMobile ? (
              // Vista móvil - Cards
              <Box>
                {filteredOrganismos.map((organismo, index) => 
                  renderMobileCard(organismo, index)
                )}
              </Box>
            ) : (
              // Vista desktop/tablet - Tabla
              <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
                <Table sx={{ minWidth: 750 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Id</TableCell>
                      <TableCell>Sigla</TableCell>
                      <TableCell>Nombre</TableCell>
                      {!isTablet && <TableCell>Nombre Abreviado</TableCell>}
                      <TableCell>Tipos de Documento</TableCell>
                      <TableCell>Habilitado</TableCell>
                      <TableCell align="center">Acciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredOrganismos.map((organismo, index) => (
                      <TableRow key={index}>
                        <TableCell>{organismo.id}</TableCell>
                        <TableCell>{organismo.sigla}</TableCell>
                        <TableCell>
                          <Box sx={{ maxWidth: 200 }}>
                            <Typography variant="body2" >
                              {organismo.nombre}
                            </Typography>
                          </Box>
                        </TableCell>
                        {!isTablet && (
                          <TableCell>
                            <Box sx={{ maxWidth: 150 }}>
                              <Typography variant="body2" noWrap>
                                {organismo.nombreAbreviado}
                              </Typography>
                            </Box>
                          </TableCell>
                        )}
                        <TableCell>
                          <Box sx={{ maxWidth: 400 }}>
                            {organismo.tipoDocumento && organismo.tipoDocumento.length > 0 ? (
                              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {organismo.tipoDocumento.map((tipo, idx) => (
                                  <Chip
                                    key={idx}
                                    label={tipo}
                                    size="small"
                                    variant="outlined"
                                  />
                                ))}
                              </Box>
                            ) : (
                              <Typography variant="body2" color="text.secondary">
                                Sin tipos asociados
                              </Typography>
                            )}
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={organismo.habilitado ? "Sí" : "No"}
                            color={organismo.habilitado ? "success" : "error"}
                            size="small"
                          />
                        </TableCell>
                        <TableCell>
                          <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                            <Tooltip title="Editar organismo">
                              <IconButton
                                color="primary"
                                onClick={() => handleOpenEditModal(organismo)}
                                size="small"
                              >
                                <EditNoteIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Gestionar tipos de documento">
                              <IconButton
                                color="primary"
                                onClick={() => handleOpenRelacionModal(organismo)}
                                size="small"
                              >
                                <SettingsIcon />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
            <TablePagination
              rowsPerPageOptions={[10, 25, 50]}
              component="div"
              count={
                organismoEmisor.filter((organismo) => {
                  const matchesSearch = organismo.nombre
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase());
                  const matchesFilter =
                    filterHabilitado === "todos" ||
                    (filterHabilitado === "habilitado" &&
                      organismo.habilitado === true) ||
                    (filterHabilitado === "deshabilitado" &&
                      organismo.habilitado === false);
                  return matchesSearch && matchesFilter;
                }).length
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </>
        ) : (
          renderNoDataMessage()
        )}
      </Grid>

      <NuevoOrganismoEmisorModal
        open={openModal}
        onClose={handleCloseModal}
        onSubmit={handleNuevoOrganismoEmisor}
        isLoading={isLoading}
      />
      
      <EditarOrganismoEmisorModal
        open={openEditModal}
        onClose={handleCloseEditModal}
        onSubmit={handleEditarOrganismoEmisor}
        organismo={organismoSeleccionado}
      />
      
      <AgregarRelacionOrganismoTipoDocumentoModal
        open={openRelacionModal}
        onClose={handleCloseRelacionModal}
        onSubmit={handleRelacionarTiposDocumento}
        organismo={organismoSeleccionado}
      />
      
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Grid>
  );
};

export default GestorOrganismoEmisor;